import axiosInstance from "@/services/http/axios-instance";

class _CentrifugoApi {
  getAccessToken() {
    return axiosInstance.get(`/cntr/tkn`);
  }
}

export const CentrifugoApi = new _CentrifugoApi();
